module.exports = __webpack_public_path__ + "static/media/sad-tear.57adcc07.svg";